import { Injectable } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Breadcrumbs } from '../models';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  constructor(
    private http: HttpClient) { }

  getParenthPath(idEntity: string, type: string): Promise<Breadcrumbs> {
    let params = new HttpParams();
    params = params.append('id-entity', idEntity);
    params = params.append('type', type);
    return this.http.get<Breadcrumbs>(`${environment.apiUrl}/Get-ParentPath`,
      {
        params,
      }
    ).toPromise();
  }
}
